<app-agent-header [activeStep]="2" mobileTitle="Test taker details"></app-agent-header>
<main class="main-container">
  <div class="agent-verification-wrapper">
    <section class="back-link-section">
      <a class="d-inline-flex gap-8 align-items-center pointer text-decoration-none" (click)="goBack()" title="Back">
        <span><img src="/assets/images/chevron-arrow-left-blue.svg" alt="chevron-arrow" class="chevronArrow object-fit-contain"></span>
        <span class="txt-baseBlue600 text-base lh-24 font-medium">Back</span>
      </a>
    </section>
    <section class="verification-card-wrapper">
      <div class="verification-card">
        <div class="verification-icon">
          <img src="/assets/images/bnb-building-withbg.svg" alt="agent" class="d-none d-lg-block">
          <img src="/assets/images/420.svg" alt="agent" class="d-block d-lg-none">
        </div>
        <div class="verification-content">
          <h2 class="verification-title">Agent verification</h2>
          <p class="verification-description">Sign in with your Referral Partner account to verify your agent registration and continue booking on behalf of test takers.</p>
          <form class="verification-form" [formGroup]="agentForm" (ngSubmit)="onVerify()">
            <div class="form-fields">
              <div class="input-wrapper">
                <input
                  class="form-input"
                  [ngClass]="(submitted || f['partnerId'].touched) && (f['partnerId'].errors?.['required'] || f['partnerId'].errors?.['pattern']) ? 'error-border' : ''"
                  placeholder="Referral partner email"
                  type="text"
                  formControlName="partnerId"
                  (blur)="onPartnerIdBlur()"
                  autocomplete="username">
                  @if (partnerIdError) {
                    <div class="error-field">
                      <img width="16" height="16" src="/assets/images/danger.svg" alt="error">
                      <span>{{ partnerIdError }}</span>
                    </div>
                  }
                </div>
                <div class="input-wrapper password-wrapper">
                  <input
                    class="form-input"
                    [ngClass]="(submitted || f['password'].touched) && (f['password'].errors?.['required'] || f['password'].errors?.['minlength'] || f['password'].errors?.['maxlength']) ? 'error-border' : ''"
                    placeholder="Enter password"
                    [type]="showPassword ? 'text' : 'password'"
                    formControlName="password"
                    [maxlength]="passwordMaxLength"
                    (blur)="onPasswordBlur()"
                    autocomplete="current-password">
                    <button type="button" class="toggle-password"
                      (click)="showPassword = !showPassword"
                      [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                      <img width="20" height="20"
                        [src]="showPassword ? '/assets/images/password-hide.svg' : '/assets/images/password-icon.svg'"
                        alt="eye">
                      </button>
                    </div>
                    @if (passwordError) {
                      <div class="error-field">
                        <img width="16" height="16" src="/assets/images/danger.svg" alt="error">
                        <span>{{ passwordError }}</span>
                      </div>
                    }
                    @if (errorMessage) {
                      <div class="error-field">
                        <img width="16" height="16" src="/assets/images/danger.svg" alt="error">
                        <span>{{ errorMessage }}</span>
                      </div>
                    }
                  </div>
                </form>
              </div>
              <button type="submit" class="verify-btn"
                [disabled]="agentForm.invalid"
                [ngClass]="agentForm.invalid ? 'btn-disabled' : ''"
              (click)="onVerify()">Verify</button>
            </div>
          </section>
        </div>
      </main>
      <footer class="mobile-footer d-flex d-lg-none align-items-center justify-content-between p-24">
        <a class="d-inline-flex gap-8 align-items-center pointer text-decoration-none" (click)="goBack()" title="Back">
          <span><img src="/assets/images/chevron-arrow-left-blue.svg" alt="chevron-arrow" class="chevronArrow object-fit-contain"></span>
          <span class="txt-baseBlue600 text-base lh-24 font-medium">Back</span>
        </a>
        <button type="button" class="mobile-verify-btn"
          [disabled]="agentForm.invalid"
          [ngClass]="agentForm.invalid ? 'btn-disabled' : ''"
        (click)="onVerify()">Verify</button>
      </footer>
